import { EditOutlined } from '@mui/icons-material';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SupplierOptionProps } from '../../SupplierContactAutocomplete.types.ts';

import { Root, Actions, supplierOptionClasses as classes } from './SupplierContactOption.styled.ts';

export const SupplierContactOption = ({ data, onSecondaryActionClick, ...props }: SupplierOptionProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'SupplierContactAutocomplete' });
  const { t: tRole } = useTranslation(undefined, { keyPrefix: 'ContactRoleVariant' });

  const roles = useMemo(() => {
    if (data.entity.roles.length) {
      const firstRole = tRole(data.entity.roles[0]);
      const additionalRoles = data.entity.roles.length - 1;
      return `${firstRole}${additionalRoles > 0 ? ` (+${additionalRoles})` : ''}, `;
    }
    return '';
  }, [data.entity.roles, tRole]);

  return (
    <Root {...props}>
      <Box
        sx={{
          flex: 1,
        }}
      >
        <Typography
          component="div"
          variant="body2"
          sx={{
            color: 'text.primary',
            display: 'block',
          }}
        >
          {data.entity.firstName} {data.entity.lastName}
        </Typography>
        <Typography
          component="div"
          variant="caption"
          sx={{
            color: 'text.secondary',
            display: 'block',
          }}
        >
          {roles}
          {data.entity.email}
        </Typography>
      </Box>
      <Actions className={classes.actions}>
        <Tooltip title={data.entity.isEditable ? t('isEditable') : t('isNotEditable')}>
          <span>
            <IconButton
              disabled={!data.entity.isEditable}
              color="default"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onSecondaryActionClick();
              }}
            >
              <EditOutlined />
            </IconButton>
          </span>
        </Tooltip>
      </Actions>
    </Root>
  );
};
